import { FetchResult, MutationFunctionOptions, useMutation } from '@apollo/client';

import {
  evictCache,
  GenerateAscReportMutation,
  GenerateAscReportMutationVariables,
  GENERATE_ASC_REPORT,
} from '@neo.tax/shared';

export const useGenerateAscReport = (): {
  generateAscReport: (
    options?: MutationFunctionOptions<GenerateAscReportMutation, GenerateAscReportMutationVariables>,
  ) => Promise<FetchResult<GenerateAscReportMutation>>;
  loading: boolean;
  called: boolean;
} => {
  const [generateAscReport, { called, loading }] = useMutation<
    GenerateAscReportMutation,
    GenerateAscReportMutationVariables
  >(GENERATE_ASC_REPORT, {
    update: (cache) => {
      evictCache(cache, ['getBackgroundOperations']);
    },
  });

  return {
    generateAscReport,
    loading,
    called,
  };
};
